<div class="flex flex-center mt-3">
  <div class="no-mobile padding-regular panel text-center">
      <div class="logo mb-5"><img src="assets/img/CC_small_colour_1.png" style="width: 35px"></div>
      <img src="assets/images/mobile.png" alt="Mobile app">
      <div class="text">Lend is not available on mobile but you can enjoy all the
          great features of Lend on your mobile phone with our mobile app</div>
      <!-- <a href="https://play.google.com/store/apps/details?id=com.creditclan.cc700lenders"
          class="btn btn-outline-secondary mt-4">Download 700 lenders</a> -->
  </div>
</div>